import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import Seo from "@/components/Seo";
import PublicLayout from "@/components/layout/PublicLayout";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Section";
import Icon from "@/components/IconMap";
import api from "@/lib/api";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);
  return (
    <PublicLayout waMessage="Hi Dreamzz HR & Consultancy, I would like to know more about your services.">
      <Seo title="Recruitment & Staffing Services" description="Explore our full range of manpower recruitment, staffing and HR consultancy services across Karnataka." />
      <PageHeader eyebrow="What We Do" title="Our Services" subtitle="End-to-end manpower, staffing and HR solutions built for every industry and workforce requirement." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((s, i) => (
          <Reveal key={s.slug} delay={i * 30}>
            <Link to={`/services/${s.slug}`} data-testid={`service-${s.slug}`} className="group glass card-hover rounded-2xl p-6 flex flex-col h-full">
              <span className="grid place-items-center h-12 w-12 rounded-xl bg-brand-emerald/15 text-brand-emerald mb-4 group-hover:scale-110 transition-transform"><Icon name={s.icon} size={22} /></span>
              <h3 className="font-display font-semibold text-lg">{s.name}</h3>
              <p className="text-sm text-slate-400 mt-2 flex-1">{s.short}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-brand-emerald font-medium">View Service <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform" /></span>
            </Link>
          </Reveal>
        ))}
      </section>
    </PublicLayout>
  );
}
